import React from "react";
import { Button } from "@mui/material";
import { useFormik } from "formik";
import { Grid, Box, } from "@mui/material";
import CategoriesFormFields from "./CategoriesFormFields";
import TabComponent from "components-base/Tab/Tab";
import { createCategories,modifyCategories, validationSchemaCategories } from "../functions";
import { useDispatch, useSelector } from "react-redux";
import { showMessage } from "store/modules/Message";

const CategoriesForm = ({ mode, handleClose }) => {
    const {defaultDataCategories} = useSelector(({category})=>category);
    const dispatch = useDispatch();
    const messages = (mensaje) =>{
        dispatch(
            showMessage({
              message: `Categories ${mensaje} con éxito`,
              variant: "success",
              anchorOrigin: {
                vertical: "top",
                horizontal: "right",
              },
            })
          );

    }
    const formik = useFormik({
        enableReinitialize: true,
        initialValues:
            mode === "POST"
                ? {
                    name: "",
                    code: "",
                    type: null,
                }
                : {
                    id: defaultDataCategories?.id,
                    name: defaultDataCategories?.name,
                    type: defaultDataCategories?.type,
                    code: defaultDataCategories?.code,
                },
        validationSchema: validationSchemaCategories,
        onSubmit: async (values) => {
            switch(mode){
                case "POST": {
                    const ok = await createCategories(values, dispatch);
                    if (ok) handleClose();
                    break;
                }
                case "PUT": {
                    const ok = await modifyCategories(values, dispatch);
                    if (ok) handleClose();
                    break;
                }
                default: handleClose();
            }
        },
    },);
    const { setFieldValue } = formik;

    return (
        <Box
            component="form"
            onSubmit={formik.handleSubmit}
            sx={{
                "& .MuiTextField-root": { marginBottom: "25px" },
            }}
            style={{ padding: "20px", justifyContent: "center" }}
        >
            <TabComponent tabsElement={[
                {
                    label: "Información de la Categorias",
                    component: <CategoriesFormFields formik={formik} mode={mode} setFieldValue={setFieldValue} />
                }
            ]} />
            <Grid container
                spacing={2}
                sx={{ display: "flex", justifyContent: "flex-end", padding: 0 }}
            >
                <Grid item sx={12} >
                    <Button onClick={handleClose} color="primary" variant="contained">
                        Cancelar
                    </Button>
                </Grid>
                <Grid item sx={12}>
                    <Button color="primary" variant="contained" type="submit">
                        Guardar
                    </Button>
                </Grid>
            </Grid>
        </Box>
    );
}
export default CategoriesForm;